import React, { useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './LoginPage.css'; // Custom CSS for additional styling

const Otp = () => {
  const location = useLocation();
  const { mobile } = location.state || {};
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [loading, setLoading] = useState(false);
  const inputRefs = [useRef(), useRef(), useRef(), useRef(), useRef(), useRef()];
  const navigate = useNavigate();

  const handleChange = (value, index) => {
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < inputRefs.length - 1) {
      inputRefs[index + 1].current.focus();
    }
  };

  const handleBackspace = (key, index) => {
    if (key === 'Backspace' && index > 0 && !otp[index]) {
      inputRefs[index - 1].current.focus();
    }
  };

  const verifyOTP = async (e) => {
    e.preventDefault();
    const otpCode = otp.join('');
    if (otpCode.length !== 6) {
      alert('Please enter a 6-digit OTP.');
      return;
    }

    setLoading(true);
    try {
      // Create FormData object
      const formData = new FormData();
      formData.append('mobile', mobile);
      formData.append('otp', otpCode);

      const response = await fetch(
        'https://easycomm.in/Rest3/web_otp_verify_api',
        {
          method: 'POST',
          body: formData,
        }
      );

      const data = await response.json();
      console.log(data);
      
      // Store user data (you might want to use context or state management instead)
      localStorage.setItem('userid', data.id);
      localStorage.setItem('name', data.first_name);
      localStorage.setItem('email', data.email);
      localStorage.setItem('mobile', data.mobile);

      navigate('/dashboard'); // Change to your dashboard route
    } catch (error) {
      console.error('Error:', error);
      alert('Something went wrong. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="otp-page">
      {/* Background Gradient */}
      <div className="gradient-bg-top"></div>
      <div className="gradient-bg-bottom"></div>

      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6 col-md-8 col-sm-10">
            {/* Header */}
            <header className="otp-header">
              <button 
                onClick={() => navigate(-1)}
                className="back-button"
              >
                <i className="fas fa-arrow-left"></i>
              </button>
              
              <h1 className="otp-title">OTP Verification</h1>
              
              <div className="spacer"></div>
            </header>

            {/* Verification Card */}
            <div className="verification-card">
              <div className="otp-icon-container">
                <i className="fas fa-sms otp-icon"></i>
              </div>
              
              <h2 className="verification-title">Enter Verification Code</h2>
              
              <p className="verification-text">
                We've sent a 6-digit code to {mobile}
              </p>
            </div>

            {/* OTP Form */}
            <form onSubmit={verifyOTP}>
              {/* OTP Input Section */}
              <div className="otp-input-section">
                <label className="otp-label">ENTER OTP</label>
                
                <div className="otp-inputs">
                  {otp.map((digit, index) => (
                    <input
                      key={index}
                      ref={inputRefs[index]}
                      type="text"
                      className="otp-digit"
                      maxLength="1"
                      inputMode="numeric"
                      value={digit}
                      onChange={(e) => handleChange(e.target.value, index)}
                      onKeyDown={(e) => handleBackspace(e.key, index)}
                    />
                  ))}
                </div>
              </div>

              {/* Submit Button */}
              <button 
                type="submit" 
                className="verify-button"
                disabled={loading}
              >
                {loading ? (
                  <div className="spinner-border spinner-border-sm" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                ) : (
                  'VERIFY OTP'
                )}
              </button>

              {/* Resend OTP */}
              <div className="resend-otp">
                <p className="resend-text">
                  Didn't receive the OTP?{' '}
                  <button type="button" className="resend-button">
                    Resend Now
                  </button>
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Otp;